module.exports = __webpack_public_path__ + "img/Vector.2f0f7a15.svg";